import bemBlock from 'bem-cn-lite';
export const NAMESPACE = 'yc-';
export const NAMESPACE_NEW = 'g-';
export function block(name) {
    return bemBlock(`${NAMESPACE}${name}`);
}
export function blockNew(name) {
    return bemBlock(`${NAMESPACE_NEW}${name}`);
}
/**
 * Extracts modifiers part from className
 */
export function modsClassName(className) {
    return className.split(/\s(.*)/)[1];
}
